import {
  ADD_INVOICE,
  DELETE_INVOICE,
  GET_INVOICE_PROFILE,
  GET_INVOICES_LIST,
  HIDE_INVOICE_LIST_LOADER,
  SET_ERROR_INVOICE_PROFILE,
  SET_INVOICE_PROFILE,
  SET_INVOICES_LIST,
  SHOW_INVOICE_LIST_LOADER,
  UPDATE_INVOICE_PROFILE,
  GET_INVOICE_CHOICE,
  SET_INVOICE_CHOICE,
  POST_INVOICE_BY_OFFER,
  POST_INVOICE_BY_SALARY,
  SET_STATUSES,
  INVOICE_PROFILE_LOADER,
  PATCH_INVOICE,
  INVOICE_MAKE_LOADER,
  GET_INVOICES_FILTER_DATA,
  SET_INVOICES_FILTER_DATA,
  LOADER_AGGREGATED_STAFF_DATA,
  SET_AGGREGATED_STAFF_DATA,
  GET_AGGREGATED_STAFF_DATA,
  ADD_CUSTOM_INVOICE
} from "./actionTypes";

export const getInvoiceChoice = () => ({
  type: GET_INVOICE_CHOICE,
});

export const setInvoiceChoice = data => ({
  type: SET_INVOICE_CHOICE,
  payload: data,
});

export const getInvoicesList = data => ({
  type: GET_INVOICES_LIST,
  payload: data,
});

export const setInvoicesList = payload => ({
  type: SET_INVOICES_LIST,
  payload,
});

export const showInvoicesListLoader = () => ({
  type: SHOW_INVOICE_LIST_LOADER,
});

export const hideInvoicesListLoader = () => ({
  type: HIDE_INVOICE_LIST_LOADER,
});

export const addInvoice = (data, history) => ({
  type: ADD_INVOICE,
  payload: { data, history },
});

export const addCustomInvoice = (data, history) => ({
  type: ADD_CUSTOM_INVOICE,
  payload: { data, history },
});

export const deleteInvoice = (id, data = {}) => ({
  type: DELETE_INVOICE,
  payload: { id, data },
});

export const getInvoiceProfile = id => ({
  type: GET_INVOICE_PROFILE,
  payload: id,
});

export const setInvoiceProfile = payload => ({
  type: SET_INVOICE_PROFILE,
  payload,
});

export const updateInvoiceProfile = (id, format = {}, data = {}) => ({
  type: UPDATE_INVOICE_PROFILE,
  payload: { id, format, data },
});

export const updateInvoice = (id, data) => ({
  type: PATCH_INVOICE,
  payload: { id, data },
});

export const setErrorInvoiceProfile = payload => ({
  type: SET_ERROR_INVOICE_PROFILE,
  payload,
});

export const postInvoiceByOffer = (data, history) => ({
  type: POST_INVOICE_BY_OFFER,
  payload: { data, history },
});

export const postInvoiceBySalary = (data, history) => ({
  type: POST_INVOICE_BY_SALARY,
  payload: { data, history },
});

export const setStatuses = data => ({
  type: SET_STATUSES,
  payload: data,
});

export const setInvoiceProfileLoader = () => ({
  type: INVOICE_PROFILE_LOADER,
});

export const setInvoiceMakeLoader = () => ({
  type: INVOICE_MAKE_LOADER,
});

export const getInvoicesFilters = () => ({
  type: GET_INVOICES_FILTER_DATA,
})

export const setInvoicesFilters = (data) => ({
  type: SET_INVOICES_FILTER_DATA,
  payload: data,
})

export const getAggregatedStaffData = (params) => ({
  type: GET_AGGREGATED_STAFF_DATA,
  payload: params
})

export const setAggregatedStaffData= (params) => ({
  type: SET_AGGREGATED_STAFF_DATA,
  payload: params
})

export const setLoaderAggregatedStaffData = () => ({
  type: LOADER_AGGREGATED_STAFF_DATA,
})